import FilterBar from '../../components/FilterBar';
import { CircularProgress, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { useFindAllCompaniesQuery } from '../../api/api-hooks';
import { UserFilter } from './userTypes';
import ToggleSwitch from '../../components/ToggleSwitch';
import { useHistory } from 'react-router-dom';

interface Props {
  filters: UserFilter;
  setFilters: React.Dispatch<any>;
  initialFilters: UserFilter;
}

const UsersFilterBar = ({ filters, setFilters, initialFilters }: Props) => {
  const { data: companies } = useFindAllCompaniesQuery({});
  const { push } = useHistory();
  if (companies === undefined) return <CircularProgress></CircularProgress>;
  return (
    <>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={initialFilters}
        filterConstraintChecker={() => true}
        children={(
          handler: (event: any, value?: any, label?: string) => void
        ) => [
          <ToggleSwitch
            options={['Users', 'Signups']}
            onClicks={[
              () => {
                push('/users');
              },
              () => {
                push('/signups');
              },
            ]}
            startingOption='Users'
          />,
          <TextField
            name='name'
            label='Filter By Name'
            variant='outlined'
            value={filters.name}
            onChange={handler}
          />,
          <TextField
            name='email'
            label='Filter By Email'
            variant='outlined'
            value={filters.email}
            onChange={handler}
          />,
          <Autocomplete
            onChange={(event, value) => {
              handler(event, value, 'company');
            }}
            value={filters.company}
            options={companies}
            getOptionLabel={(company) => company.companyName}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Filter By Company'
                name='company'
                variant='outlined'
                id='company'
              />
            )}
          />,
        ]}
      />
    </>
  );
};

export default UsersFilterBar;
